import React, { useContext, useState, useEffect } from "react";

// import ShareProfileImg from "../../assets/images/shareProfile.png";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { BsArrowLeft } from "react-icons/bs";

import { Carousel } from "react-bootstrap";
import { axiosInstance_agent } from "../../axiosInstance-agent";
import { toast } from "react-toastify";

export function ViewProfile() {
  const [profileData, setProfileData] = useState({});
  //   const location = useLocation();
  //   const { Details } = location.state || {};
  // if there are not multiple images we are showing profile as default
  const images = profileData.images || [];
  const profile = profileData?.profile;

  const location = useLocation();
  // const { userId, profileId, matchmakerName,planType } = location.state || {};
    const {profileId } = location.state || {};
  // console.log("User ID:", userId);
  console.log("ProfileId", profileId);
  const navigate = useNavigate();

const storedData = JSON.parse(sessionStorage.getItem("matchmakerProfileData")) || {};
const {  agentId, matchmakerName, planType, publicToken,email,mobile} = storedData;

  async function LoadProfile(profileId) {
    try {
      const response = await axiosInstance_agent.get(
        `/admin/biodata/${profileId}`
      );
      if (response.data.status === true || response.status === 200) {
        setProfileData(response.data.data);
      }
    } catch (error) {
      toast.error(error.response.data.message || "Failed to fetch profile!");
    }
  }
  useEffect(() => {
    if (profileId) {
      LoadProfile(profileId);
    }
  }, [profileId]);
  return (
    <div className="viewmoreBg shareProfile-container">
      <div className="container">
        <div className="agency-name d-flex">
          {" "}
          <div
            onClick={() =>
              navigate("/matchmaker-profiles-uploaded", {
                // state: {
                //   userId: userId,
                //   matchmakerName: matchmakerName,
                //   planType:planType,
                // },
              })
            }
            style={{ color: "#2B171B", marginRight: "10px" }}
          >
            {" "}
            <span>
              <BsArrowLeft />
            </span>
          </div>
          {/* {agency ? agency : "Nathicharami Agency"} */}
          Agent Name :{" "}
          <span style={{ color: "#524f4f", marginLeft: "10px" }}>
            {matchmakerName ?? "__"}
          </span>
        </div>
        <div className="share-title">Bio Data</div>
        <div className="view-container">
          <div className="viewImg">
            {images.length > 0 ? (
              <Carousel
                className="profileCarousel"
              >
                {images.map((img, index) => (
                  <Carousel.Item key={index}>
                    <a
                      href={img.image}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        className="d-block w-100"
                        src={img.image}
                        alt={`Slide ${index + 1}`}
                        style={{ maxHeight: "400px", objectFit: "contain" }}
                      />
                    </a>
                  </Carousel.Item>
                ))}
              </Carousel>
            ) : (
              <div className="altprofileviewImg">
                <img src={profile} alt="No profile available" />
              </div>
            )}
          </div>
          <div className="shareProfile-name">{profileData.name}</div>
          <div className="view-subcontainer">
            <div className="view-subcontainer-left">
              <div className="shareprofile-subtitle">Personal Details :</div>
              <div className="profile-detailsContainer">
                <div>Gender</div>
                <div>:</div>

                <div>{profileData.gender}</div>
              </div>
              <div className="profile-detailsContainer">
                <div>Date Of Birth</div>
                <div>:</div>
                <div>{profileData.dob}</div>
              </div>
              <div className="profile-detailsContainer">
                <div>Age</div>
                <div>:</div>
                <div>{profileData.age}</div>
              </div>
              <div className="profile-detailsContainer">
                <div>Time Of Birth</div>
                <div>:</div>
                <div>{profileData.tob}</div>
              </div>
              <div className="profile-detailsContainer">
                <div>Place Of Birth</div>
                <div>:</div>
                <div>{profileData.pob}</div>
              </div>
              <div className="profile-detailsContainer">
                <div>Rashi</div>
                <div>:</div>
                <div>{profileData.rashi}</div>
              </div>
              <div className="profile-detailsContainer">
                <div>Nakshatra</div>
                <div>:</div>
                <div>{profileData.nakshatra}</div>
              </div>
              <div className="profile-detailsContainer">
                <div>Height</div>
                <div>:</div>
                <div>{profileData.height}</div>
              </div>
              <div className="profile-detailsContainer">
                <div>Marital Status</div>
                <div>:</div>
                <div>{profileData.marital_status}</div>
              </div>
              <div className="profile-detailsContainer">
                <div>Religion</div>
                <div>:</div>
                <div>{profileData.religion}</div>
              </div>
              <div className="profile-detailsContainer">
                <div>Mother Tongue</div>
                <div>:</div>
                <div>{profileData.mother_tongue}</div>
              </div>
              <div className="profile-detailsContainer">
                <div>Caste</div>
                <div>:</div>
                <div>{profileData.caste}</div>
              </div>
              <div className="profile-detailsContainer">
                <div>Sub Caste</div>
                <div>:</div>
                <div>{profileData.sub_caste}</div>
              </div>
              <div className="profile-detailsContainer">
                <div>Gothram</div>
                <div>:</div>
                <div>{profileData.gotra}</div>
              </div>
              <div className="profile-detailsContainer">
                <div>Manglik</div>
                <div>:</div>
                <div>{profileData.manglik}</div>
              </div>
              <div className="profile-detailsContainer">
                <div>Education</div>
                <div>:</div>
                <div>{profileData.education}</div>
              </div>
              <div className="profile-detailsContainer">
                <div>College Name</div>
                <div>:</div>
                <div>{profileData.college_name}</div>
              </div>
              <div className="profile-detailsContainer">
                <div>Employee Designation</div>
                <div>:</div>
                <div>{profileData.employed_in}</div>
              </div>
              <div className="profile-detailsContainer">
                <div>Organization Name</div>
                <div>:</div>
                <div>{profileData.organization_name}</div>
              </div>
              <div className="profile-detailsContainer">
                <div>Annual Income</div>
                <div>:</div>
                <div>{profileData.annual_income}</div>
              </div>
            </div>
            <div className="view-subcontainer-right">
              <div className="shareprofile-subtitle">Family Details:</div>
              <div className="profile-detailsContainer">
                <div>Father’s Name</div>
                <div>:</div>
                <div>{profileData.father_name}</div>
              </div>
              <div className="profile-detailsContainer">
                <div>Father’s Occupation</div>
                <div>:</div>
                <div>{profileData.father_occupation}</div>
              </div>
              <div className="profile-detailsContainer">
                <div>Mother’s Name</div>
                <div>:</div>
                <div>{profileData.mother_name}</div>
              </div>
              <div className="profile-detailsContainer">
                <div>Mother’s Occupation</div>
                <div>:</div>
                <div>{profileData.mother_occupation}</div>
              </div>
              <div className="profile-detailsContainer">
                <div>No. of Brothers</div>
                <div>:</div>
                <div>{profileData.total_brothers}</div>
              </div>
              <div className="profile-detailsContainer">
                <div>No. of Sisters</div>
                <div>:</div>
                <div>{profileData.total_sisters}</div>
              </div>
              <div className="profile-detailsContainer">
                <div>Married Brothers</div>
                <div>:</div>
                <div>{profileData.married_brothers}</div>
              </div>
              <div className="profile-detailsContainer">
                <div>Married Sisters</div>
                <div>:</div>
                <div>{profileData.married_sisters}</div>
              </div>

              <div className="shareprofile-subtitle">Contact Details :</div>
              <div className="profile-detailsContainer">
                <div> Contact Number</div>
                <div>:</div>
                <div>{profileData.contact_number}</div>
              </div>
              <div className="profile-detailsContainer">
                <div>State</div>
                <div>:</div>
                <div>{profileData.state}</div>
              </div>
              <div className="profile-detailsContainer">
                <div>City</div>
                <div>:</div>
                <div>{profileData.city}</div>
              </div>
              <div className="profile-detailsContainer">
                <div>Address</div>
                <div>:</div>
                <div>{profileData.address}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
